import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./i18n";
import App from "./App";
import  "./index.css"
import 'react-phone-number-input/style.css';

import reportWebVitals from "./reportWebVitals";

// ReactDOM.render(<App />, document.getElementById("root"));
// console.warn = () => {};
// console.error = () => {};

if(process.env.NODE_ENV ==="production"){
 console.warn = () => {};
 console.error = () => {};
 console.log =()=>{}
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render( <App />   );
navigator.serviceWorker.register("/firebase-messaging-sw.js");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
